import { Linkedin } from "lucide-react";
import banetechLogo from "@/assets/banetech-logo.webp";

export const Footer = () => {
  return (
    <footer className="border-t border-border py-10">
      <div className="container flex flex-col xl:flex-row items-center xl:justify-between gap-6 text-sm text-muted-foreground text-center">
        <div className="flex items-center gap-3 leading-none">
          <img src={banetechLogo} alt="Bane Tech" width={117} height={28} className="h-7 w-auto block" />
          <span className="leading-none">© {new Date().getFullYear()}</span>
        </div>
        <p className="font-mono text-xs">High-performance Integration · Observability · Architecture · Real-time Intelligence</p>
        <a
          href="https://www.linkedin.com/company/bane-tech"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Bane Tech on LinkedIn"
          className="inline-flex items-center gap-2 hover:text-foreground transition-colors"
        >
          <Linkedin className="h-4 w-4" />
        </a>
      </div>
    </footer>
  );
};
